import React from "react";
import { Routes, Route } from "react-router-dom";

// Public Pages
import LoginContainer from "../containers/LoginContainer";
import RegisterContainer from "../containers/RegisterContainer";

// Protected Pages
import DashboardContainer from "../containers/DashboardContainer";

import BuildingContainer from "../containers/BuildingContainer";
import CreateUpdateBuilding from "../pages/building/CreateUpdateBuilding";

import RentalPropertyContainer from "../containers/RentalPropertyContainer";
import CreateUpdateRentalProperty from "../pages/rental-property/CreateUpdateRentalProperty";

import TenantContainer from "../containers/TenantContainer";
import CreateUpdateTenant from "../pages/tenant/CreateUpdateTenant";

import InvoiceContainer from "../containers/InvoiceContainer";
import GenerateInvoice from "../pages/invoice/GenerateInvoice";

import ReportContainer from "../containers/ReportContainer";

import SettingContainer from "../containers/SettingContainer";
import Backup from "../pages/settings/backup/Backup";

import ProtectedRoute from "./ProtectedRoute";
import UserProfile from "../pages/profile/UserProfile";
import { ResetPassword } from "../pages/forgetPassword/ResetPassword";
import { ROUTE_PATHS } from "./routePaths";


const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path={ROUTE_PATHS.PUBLIC_ROUTES.DEFAULT} element={<LoginContainer />} />
      <Route path={ROUTE_PATHS.PUBLIC_ROUTES.LOGIN} element={<LoginContainer />} />
      <Route path={ROUTE_PATHS.PUBLIC_ROUTES.REGISTER} element={<RegisterContainer />} />
      <Route path={ROUTE_PATHS.PUBLIC_ROUTES.RESET_PASSWORD} element={<ResetPassword />} />

      {/* Protected Routes */}

      {/* -------------- DASHBOARD -------------- */}
      <Route path={ROUTE_PATHS.DASHBOARD.LIST} element={<ProtectedRoute><DashboardContainer /></ProtectedRoute>} />

      {/* -------------- BUILDING -------------- */}
      <Route path={ROUTE_PATHS.BUILDING.LIST} element={<ProtectedRoute><BuildingContainer /></ProtectedRoute>} />
      <Route path={ROUTE_PATHS.BUILDING.ADD} element={<ProtectedRoute><CreateUpdateBuilding /></ProtectedRoute>} />
      <Route path={ROUTE_PATHS.BUILDING.EDIT} element={<ProtectedRoute><CreateUpdateBuilding /></ProtectedRoute>} />

      {/* -------------- RENTAL_PROPERTY -------------- */}
      <Route path={ROUTE_PATHS.RENTAL_PROPERTY.LIST} element={<ProtectedRoute><RentalPropertyContainer /></ProtectedRoute>} />
      <Route path={ROUTE_PATHS.RENTAL_PROPERTY.ADD} element={<ProtectedRoute><CreateUpdateRentalProperty /></ProtectedRoute>} />
      <Route path={ROUTE_PATHS.RENTAL_PROPERTY.EDIT} element={<ProtectedRoute><CreateUpdateRentalProperty /></ProtectedRoute>} />

      {/* -------------- TENANT -------------- */}
      <Route path={ROUTE_PATHS.TENANT.LIST} element={<ProtectedRoute><TenantContainer /></ProtectedRoute>} />
      <Route path={ROUTE_PATHS.TENANT.ADD} element={<ProtectedRoute><CreateUpdateTenant /></ProtectedRoute>} />
      <Route path={ROUTE_PATHS.TENANT.EDIT} element={<ProtectedRoute><CreateUpdateTenant /></ProtectedRoute>} />

      {/* -------------- INVOICE -------------- */}
      <Route path={ROUTE_PATHS.INVOICE.LIST} element={<ProtectedRoute><InvoiceContainer /></ProtectedRoute>} />
      <Route path={ROUTE_PATHS.INVOICE.ADD} element={<ProtectedRoute><GenerateInvoice /></ProtectedRoute>} />
      <Route path={ROUTE_PATHS.INVOICE.EDIT} element={<ProtectedRoute><GenerateInvoice /></ProtectedRoute>} />

      {/* -------------- REPORT -------------- */}
      <Route path={ROUTE_PATHS.REPORT.LIST} element={<ProtectedRoute><ReportContainer /></ProtectedRoute>} />

      {/* -------------- USER PROFILE -------------- */}
      <Route path={ROUTE_PATHS.USER.PROFILE} element={<ProtectedRoute><UserProfile /></ProtectedRoute>} />

      {/* -------------- SETTING -------------- */}
      <Route path={ROUTE_PATHS.SETTING.LIST} element={<ProtectedRoute><SettingContainer /></ProtectedRoute>} />
      <Route path="/backup" element={<ProtectedRoute><Backup /></ProtectedRoute>} />

    </Routes>
  );
};

export default AppRoutes;
